export const COMMIT_HASH = '5a785f2fb9122f5bf569438ff6bc861b9a2aa431';
